import http from "../http-common";

class SetTopBoxTypeDataService {
    getAll() {
        return http.get("/boxtypes");
    }

    get(id) {
        return http.get(`/boxtypes/${id}`);
    }

    create(data) {
        return http.post("/boxtypes", data);
    }

    update(id, data) {
        return http.put(`/boxtypes/${id}`, data);
    }

    delete(id) {
        return http.delete(`/boxtypes/${id}`);
    }

    deleteAll() {
        return http.delete(`/boxtypes`);
    }

    findByName(name) {
        return http.get(`/boxtypes?name=${name}`);
    }
}

export default new SetTopBoxTypeDataService();
